import axios from "axios";
import { Base_URL } from "../url";

// Fetch all tickets
export const getAllTickets = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketBasedOrganization/GetAllTickets`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching tickets:", error);
    throw error;
  }
};

// NEW: Fetch ticket by ticketId
export const getTicketByTicketId = async (ticketId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketBasedOrganization/GetByTicketId/${ticketId}`,
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching ticket with ID ${ticketId}:`, error);
    throw error;
  }
};

// NEW: Fetch tickets by Assigned Resource ID
export const getTicketsByAssignedResource = async (resourceId) => {
  try {
    if (!resourceId) {
      throw new Error("resourceId is required");
    }

    const response = await axios.get(
      `${Base_URL}/TicketBasedOrganization/GetByAssignedResource/${resourceId}`,
    );

    return response.data;
  } catch (error) {
    console.error(
      `Error fetching tickets for assigned resource ${resourceId}:`,
      error,
    );
    throw error.response?.data || error;
  }
};

// Fetch tickets by orgId
export const getTicketsByOrgId = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketBasedOrganization/GetByOrgId/${orgId}`,
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching tickets for orgId ${orgId}:`, error);
    throw error;
  }
};

// Create new ticket

export const createTicket = async (data) => {
  return axios.post(`${Base_URL}/TicketBasedOrganization/CreateTicket`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
// export const createTicket = async (ticketData) => {
//   try {
//     const response = await axios.post(
//       `${Base_URL}/TicketBasedOrganization/CreateTicket`,
//       ticketData,
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Error creating ticket:", error);
//     throw error;
//   }
// };

// Fetch tickets by projectId
export const getTicketsByProjectId = async (projectId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketBasedOrganization/GetByProjectId/${projectId}`,
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching tickets for projectId ${projectId}:`, error);
    throw error;
  }
};

// Update existing ticket
export const updateTicket = async (ticketId, ticketData) => {
  try {
    const response = await axios.put(
      `${Base_URL}/TicketBasedOrganization/UpdateTicket/${ticketId}`,
      ticketData,
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating ticket ${ticketId}:`, error);
    throw error;
  }
};

// Microsoft OAuth APIs
export const microsoftOAuthApi = {
  // Start OAuth flow
  connectOrganization: async (orgId) => {
    const response = await axios.get(
      `${Base_URL}/MicrosoftOAuth/Connect/${orgId}`,
    );
    return response.data;
  },

  // Check connection status
  getConnectionStatus: async (orgId) => {
    const response = await axios.get(
      `${Base_URL}/MicrosoftOAuth/Status/${orgId}`,
    );
    return response.data;
  },

  // Disconnect organization
  disconnectOrganization: async (orgId) => {
    const response = await axios.delete(
      `${Base_URL}/MicrosoftOAuth/Disconnect/${orgId}`,
    );
    return response.data;
  },

  // Test email connection
  testEmailConnection: async (orgId) => {
    const response = await axios.post(
      `${Base_URL}/EmailProcessing/TestConnection/${orgId}`,
    );
    return response.data;
  },
};

// Organization Email APIs
export const organizationEmailApi = {
  // Get all organization emails
  getAllOrganizationEmails: async () => {
    const response = await axios.get(
      `${Base_URL}/OrganizationEmailsForTicket/GetAllOrganizationEmails`,
    );
    return response.data;
  },

  // Get emails by orgId
  getEmailsByOrgId: async (orgId) => {
    const response = await axios.get(
      `${Base_URL}/OrganizationEmailsForTicket/GetByOrgId/${orgId}`,
    );
    return response.data;
  },

  // Create organization email
  createOrganizationEmail: async (emailData) => {
    const response = await axios.post(
      `${Base_URL}/OrganizationEmailsForTicket/CreateOrganizationEmail`,
      emailData,
    );
    return response.data;
  },

  // Create multiple organization emails
  createMultipleOrganizationEmails: async (emailsData) => {
    const response = await axios.post(
      `${Base_URL}/OrganizationEmailsForTicket/CreateMultipleOrganizationEmails`,
      emailsData,
    );
    return response.data;
  },
};

// Email Processing APIs
export const emailProcessingApi = {
  // Process emails for organization
  processOrganizationEmails: async (orgId) => {
    const response = await axios.post(
      `${Base_URL}/EmailProcessing/ProcessOrganizationEmails/${orgId}`,
    );
    return response.data;
  },

  // Process all organizations emails
  processAllOrganizationsEmails: async () => {
    const response = await axios.post(
      `${Base_URL}/EmailProcessing/ProcessAllOrganizationsEmails`,
    );
    return response.data;
  },

  // Test email connection
  testEmailConnection: async (orgId) => {
    const response = await axios.post(
      `${Base_URL}/EmailProcessing/TestConnection/${orgId}`,
    );
    return response.data;
  },
};

// Attachment APIs
export const attachmentApi = {
  // Get ticket attachments
  getTicketAttachments: async (ticketId) => {
    const response = await axios.get(
      `${Base_URL}/TicketBasedOrganization/GetTicketAttachments/${ticketId}`,
    );
    return response.data;
  },

  // Download attachment
  downloadAttachment: async (blobUrl, fileName) => {
    const response = await axios.get(
      `${Base_URL}/TicketBasedOrganization/DownloadAttachment`,
      {
        params: { blobUrl, fileName },
        responseType: "blob", // Important for file downloads
      },
    );
    return response;
  },

  // View attachment in browser
  viewAttachment: async (blobUrl, fileName) => {
    const response = await axios.get(
      `${Base_URL}/TicketBasedOrganization/ViewAttachment`,
      {
        params: { blobUrl, fileName },
        responseType: "blob",
      },
    );
    return response;
  },
};

// =====================================
// 🎯 Ticket Assignment Tracking APIs
// =====================================

// ✅ Start Work
export const startWork = async (ticketId, userId, orgId) => {
  const response = await axios.post(
    `${Base_URL}/TicketAssignmentTracking/StartWork`,
    {
      TicketId: ticketId,
      AssignedUserId: userId,
      OrgId: orgId?.toString(),
    },
  );
  return response.data;
};

// ✅ Stop Work
export const stopWork = async (assignmentId) => {
  const response = await axios.post(
    `${Base_URL}/TicketAssignmentTracking/StopWork/${assignmentId}`,
  );
  return response.data;
};

// ✅ Get all assignments
export const getAllAssignments = async () => {
  const response = await axios.get(
    `${Base_URL}/TicketAssignmentTracking/GetAllAssignments`,
  );
  return response.data;
};

// ✅ Get assignments by ticketId
export const getAssignmentsByTicketId = async (ticketId) => {
  const response = await axios.get(
    `${Base_URL}/TicketAssignmentTracking/GetByTicketId/${ticketId}`,
  );
  return response.data;
};

// ✅ Get active assignments
export const getActiveAssignments = async () => {
  const response = await axios.get(
    `${Base_URL}/TicketAssignmentTracking/GetActiveAssignments`,
  );
  return response.data;
};

// ✅ Update assignment
export const updateAssignment = async (assignmentId, updateData) => {
  const response = await axios.put(
    `${Base_URL}/TicketAssignmentTracking/UpdateAssignment/${assignmentId}`,
    updateData,
  );
  return response.data;
};

// ✅ Get ticket assignments by AssignedUserId & OrgId
export const getTicketAssignmentsByUserAndOrg = async (
  assignedUserId,
  orgId,
) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketAssignmentTracking/GetByUserAndOrg/${assignedUserId}/${orgId}`,
    );

    // Backend returns [] when no data → safe for UI
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    // 🚫 Do NOT throw error for no data
    if (error?.response?.status === 404) {
      return [];
    }

    console.error(
      `Error fetching ticket assignments for user ${assignedUserId} in org ${orgId}:`,
      error,
    );

    // Return empty list instead of breaking UI
    return [];
  }
};

export const addTicketLog = async (payload) => {
  return axios.post(`${Base_URL}/TicketLog/AddLog`, payload);
};

// =====================================
// 🎯 Ticket Closure Type APIs
// =====================================

// Fetch all ticket closure types
export const getAllTicketClosureTypes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/TicketClosureType/GetAll`);

    return response.data;
  } catch (error) {
    console.error("Error fetching ticket closure types:", error);
    throw error;
  }
};

// =====================================
// 🎯 Ticket Closure APIs
// =====================================

// Close ticket with multiple efforts
export const closeTicket = async (payload) => {
  try {
    const response = await axios.post(
      `${Base_URL}/TicketLog/CloseTicket`,
      payload,
    );

    return response.data;
  } catch (error) {
    console.error("❌ Error closing ticket:", error);
    throw error;
  }
};

// =====================================
// 🎯 Ticket Logged Type APIs
// =====================================

// 🔹 Get all active ticket logged types
export const getAllTicketLoggedTypes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/TicketLoggedType/GetAll`);
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching ticket logged types:", error);
    throw error;
  }
};

// 🔹 Get ticket logged type by code
export const getTicketLoggedTypeByCode = async (code) => {
  try {
    if (!code) {
      throw new Error("Logged type code is required");
    }

    const response = await axios.get(
      `${Base_URL}/TicketLoggedType/GetByCode/${code}`,
    );

    return response.data;
  } catch (error) {
    console.error(
      `❌ Error fetching ticket logged type for code ${code}:`,
      error,
    );
    throw error;
  }
};

// =====================================
// 🎯 Ticket Log APIs
// =====================================

// 🔹 Get ticket logs by TicketId
export const getTicketLogsByTicketId = async (ticketId) => {
  try {
    if (!ticketId) {
      throw new Error("TicketId is required");
    }

    const response = await axios.get(
      `${Base_URL}/TicketLog/GetByTicketId/${ticketId}`,
    );

    // Backend returns 404 when no logs → UI-safe
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    // 🚫 No logs is NOT an error
    if (error?.response?.status === 404) {
      return [];
    }

    console.error(
      `❌ Error fetching ticket logs for TicketId ${ticketId}:`,
      error,
    );
    throw error;
  }
};

// =====================================
// 🎯 Ticket → Tasks + Logs APIs
// =====================================

// 🔹 Get tasks (TaskMaster) with logs (TaskLogOrg) by TicketId
export const getTasksByTicketId = async (ticketId) => {
  try {
    if (!ticketId) {
      throw new Error("TicketId is required");
    }

    const response = await axios.get(
      `${Base_URL}/TaskMaster/GetTasksByTicket/${ticketId}`,
    );

    // ✅ If backend sends array
    if (Array.isArray(response.data)) {
      return response.data;
    }

    // ✅ If backend sends message
    if (response.data?.message) {
      return [];
    }

    return [];
  } catch (error) {
    // backend may return 404
    if (error?.response?.status === 404) {
      return [];
    }

    console.error(
      `❌ Error fetching tasks & logs for TicketId ${ticketId}:`,
      error,
    );

    return [];
  }
};
// NEW: Get Building Block by Ticket
export const getBuildingBlockByTicket = async (ticketId) => {
  try {
    const res = await axios.get(
      `${Base_URL}/BuildingBlockMaster/GetBuildingBlockByTicket/${ticketId}`,
    );

    return res.data;
  } catch (error) {
    if (error.response?.status === 404) {
      return null; // ✅ handle gracefully
    }

    throw error;
  }
};

// =====================================
// 🎯 Ticket Work Log API
// =====================================

export const addTicketWorkLog = async (payload) => {
  return axios.post(`${Base_URL}/TicketLog/AddLog`, {
    ...payload,
    actionType: "WORK_LOG",
  });
};

// 🔹 Fetch tickets by FromMail
export const getTicketsByFromMail = async (email) => {
  const response = await axios.get(
    `${Base_URL}/TicketBasedOrganization/GetByFromMail`,
    { params: { email } },
  );
  return response.data;
};

// =====================================
// 🎯 Ticket Conversation APIs
// =====================================

export const getTicketThread = async (ticketId) => {
  const response = await axios.get(`${Base_URL}/tickets/${ticketId}/thread`);
  return response.data;
};

export const addTicketReply = async (ticketId, formData) => {
  const response = await axios.post(
    `${Base_URL}/tickets/${ticketId}/reply`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const addInternalNote = async (ticketId, note, createdBy) => {
  const response = await axios.post(
    `${Base_URL}/tickets/${ticketId}/internal-note`,
    note,
    {
      params: { createdBy },
    },
  );
  return response.data;
};

// =====================================
// 🎯 Ticket Remarks APIs
// =====================================

// 🔹 Add remark to ticket
export const addTicketRemark = async (payload) => {
  try {
    const response = await axios.post(
      `${Base_URL}/TicketBasedOrganization/AddRemark`,
      payload,
    );

    return response.data;
  } catch (error) {
    console.error("❌ Error adding ticket remark:", error);
    throw error;
  }
};

// 🔹 Get remarks by TicketId
export const getTicketRemarks = async (ticketId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketBasedOrganization/GetRemarks/${ticketId}`,
    );

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    if (error?.response?.status === 404) {
      return [];
    }

    console.error("❌ Error fetching ticket remarks:", error);
    throw error;
  }
};

export const getTicketSla = async (ticketId) => {
  const res = await axios.get(
    `${Base_URL}/TicketBasedOrganization/GetTicketSla/${ticketId}`,
  );
  return res.data;
};

export const getTicketSlaLogs = async (ticketId) => {
  const res = await axios.get(
    `${Base_URL}/TicketBasedOrganization/GetTicketSlaLogs/${ticketId}`,
  );
  return res.data;
};

export const resolveNamesApi = async (ids) => {
  try {
    const response = await axios.post(`${Base_URL}/Resource/ResolveNames`, ids);
    return response.data;
  } catch (error) {
    console.error("❌ Error resolving names:", error);
    return [];
  }
};

// ✅ NEW: Get full dropdown hierarchy
export const getTicketDropdownData = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketDropdown/full`,
      { params: { orgId } }, // ✅ pass orgId
    );
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching dropdown data:", error);
    throw error;
  }
};

// ✅ NEW: Resolve names for multiple IDs
export const resolveNames = async (
  typeGuids = [],
  reasonCodes = [],
  categoryGuids = [],
) => {
  try {
    const response = await axios.post(
      `${Base_URL}/TicketDropdown/resolve-names`,
      {
        typeGuids,
        reasonCodes,
        categoryGuids,
      },
    );
    return response.data;
  } catch (error) {
    console.error("❌ Error resolving names:", error);
    return { typeNames: {}, reasonNames: {}, categoryNames: {} };
  }
};

// ✅ NEW: Add Category
export const addCategory = async (payload) => {
  try {
    const response = await axios.post(
      `${Base_URL}/TicketDropdown/add-category`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("❌ Error adding category:", error);
    throw error;
  }
};

// =====================================================
// 🎯 TICKET STATUS MASTER APIs
// =====================================================

// Get all active statuses (main statuses with their sub-statuses)
export const getAllTicketStatuses = async () => {
  try {
    const response = await axios.get(`${Base_URL}/TicketStatusMaster/GetAll`);
    return response.data;
  } catch (error) {
    console.error("Error fetching all statuses:", error);
    throw error;
  }
};

// Get all main statuses only
export const getMainTicketStatuses = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketStatusMaster/GetMainStatuses`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching main statuses:", error);
    throw error;
  }
};

// Get sub-statuses for a specific main status
export const getSubStatuses = async (parentStatusGuid) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketStatusMaster/GetSubStatuses/${parentStatusGuid}`,
    );
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching sub-statuses for parent ${parentStatusGuid}:`,
      error,
    );
    throw error;
  }
};

// Get status by GUID
export const getTicketStatusByGuid = async (statusGuid) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketStatusMaster/GetByGuid/${statusGuid}`,
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching status with GUID ${statusGuid}:`, error);
    throw error;
  }
};

// Get status by StatusId (e.g., 'OPEN', 'CLOSED')
export const getTicketStatusByStatusId = async (statusId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketStatusMaster/GetByStatusId/${statusId}`,
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching status with ID ${statusId}:`, error);
    throw error;
  }
};

// Create a new status
export const createTicketStatus = async (statusData) => {
  try {
    const response = await axios.post(
      `${Base_URL}/TicketStatusMaster/Create`,
      statusData,
    );
    return response.data;
  } catch (error) {
    console.error("Error creating status:", error);
    throw error;
  }
};

// Update an existing status
export const updateTicketStatus = async (statusGuid, statusData) => {
  try {
    const response = await axios.put(
      `${Base_URL}/TicketStatusMaster/Update/${statusGuid}`,
      statusData,
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating status ${statusGuid}:`, error);
    throw error;
  }
};

// Delete a status (soft delete)
export const deleteTicketStatus = async (statusGuid, deletedBy) => {
  try {
    const response = await axios.delete(
      `${Base_URL}/TicketStatusMaster/Delete/${statusGuid}`,
      {
        params: { deletedBy },
      },
    );
    return response.data;
  } catch (error) {
    console.error(`Error deleting status ${statusGuid}:`, error);
    throw error;
  }
};

// Bulk create multiple statuses
export const bulkCreateTicketStatuses = async (bulkData) => {
  try {
    const response = await axios.post(
      `${Base_URL}/TicketStatusMaster/BulkCreate`,
      bulkData,
    );
    return response.data;
  } catch (error) {
    console.error("Error bulk creating statuses:", error);
    throw error;
  }
};

// Get status hierarchy tree
export const getTicketStatusTree = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketStatusMaster/GetStatusTree`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching status tree:", error);
    throw error;
  }
};

// Get default sub-status for a main status
export const getDefaultSubStatus = async (parentStatusGuid) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketStatusMaster/GetDefaultSubStatus/${parentStatusGuid}`,
    );
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching default sub-status for parent ${parentStatusGuid}:`,
      error,
    );
    throw error;
  }
};

// Reorder statuses
export const reorderTicketStatuses = async (statusOrder) => {
  try {
    const response = await axios.put(`${Base_URL}/TicketStatusMaster/Reorder`, {
      statusOrder,
    });
    return response.data;
  } catch (error) {
    console.error("Error reordering statuses:", error);
    throw error;
  }
};

// =====================================
// 🎯 Ticket Work Summary APIs (NEW)
// =====================================

/**
 * Get combined work summary by user (Assignments + Work Logs)
 * @param {string} userId - User ID to get summary for
 * @param {string} orgId - Optional organization ID filter
 */
export const getUserWorkSummary = async (userId, orgId = null) => {
  try {
    const params = orgId ? { orgId } : {};
    const response = await axios.get(
      `${Base_URL}/TicketWorkSummary/GetUserWorkSummary/${userId}`,
      { params },
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching work summary for user ${userId}:`, error);
    throw error;
  }
};

/**
 * Get combined work details by ticket ID (Assignments + Work Logs)
 * @param {string} ticketId - Ticket ID to get details for
 * @param {string} userId - Optional user ID filter
 */
export const getTicketWorkDetails = async (ticketId, userId = null) => {
  try {
    const params = userId ? { userId } : {};
    const response = await axios.get(
      `${Base_URL}/TicketWorkSummary/GetTicketWorkDetails/${ticketId}`,
      { params },
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching work details for ticket ${ticketId}:`, error);
    throw error;
  }
};

/**
 * Compare user work logs vs assignments (discrepancy analysis)
 * @param {string} userId - User ID to compare
 * @param {string} fromDate - Optional start date (ISO format)
 * @param {string} toDate - Optional end date (ISO format)
 */
export const compareUserWork = async (
  userId,
  fromDate = null,
  toDate = null,
) => {
  try {
    const params = {};
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;

    const response = await axios.get(
      `${Base_URL}/TicketWorkSummary/CompareUserWork/${userId}`,
      { params },
    );
    return response.data;
  } catch (error) {
    console.error(`Error comparing work for user ${userId}:`, error);
    throw error;
  }
};

/**
 * Get all work logs with their corresponding assignment details
 * @param {string} userId - Optional user ID filter
 * @param {string} ticketId - Optional ticket ID filter
 * @param {string} fromDate - Optional start date (ISO format)
 * @param {string} toDate - Optional end date (ISO format)
 */
export const getWorkLogsWithAssignments = async (
  userId = null,
  ticketId = null,
  fromDate = null,
  toDate = null,
) => {
  try {
    const params = {};
    if (userId) params.userId = userId;
    if (ticketId) params.ticketId = ticketId;
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;

    const response = await axios.get(
      `${Base_URL}/TicketWorkSummary/GetWorkLogsWithAssignments`,
      { params },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching work logs with assignments:", error);
    throw error;
  }
};

/**
 * Get organization work dashboard summary
 * @param {string} orgId - Organization ID
 * @param {string} fromDate - Optional start date (ISO format)
 * @param {string} toDate - Optional end date (ISO format)
 */
export const getOrgWorkDashboard = async (
  orgId,
  fromDate = null,
  toDate = null,
) => {
  try {
    const params = {};
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;

    const response = await axios.get(
      `${Base_URL}/TicketWorkSummary/GetOrgWorkDashboard/${orgId}`,
      { params },
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching work dashboard for org ${orgId}:`, error);
    throw error;
  }
};

/**
 * Get detailed work log information for a specific user
 * @param {string} userId - User ID
 * @param {string} ticketId - Optional ticket ID filter
 * @param {string} fromDate - Optional start date (ISO format)
 * @param {string} toDate - Optional end date (ISO format)
 */
export const getUserWorkLogDetails = async (
  userId,
  ticketId = null,
  fromDate = null,
  toDate = null,
) => {
  try {
    const params = {};
    if (ticketId) params.ticketId = ticketId;
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;

    const response = await axios.get(
      `${Base_URL}/TicketWorkSummary/GetUserWorkLogDetails/${userId}`,
      { params },
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching work log details for user ${userId}:`, error);
    throw error;
  }
};

// =====================================
// 🎯 Ticket Dropdown (NEW - SP Based)
// =====================================

export const ticketDropdownApi = {
  // 🔹 Submitted By
  getSubmittedBy: async (orgId) => {
    try {
      const response = await axios.get(
        `${Base_URL}/TicketDropdownData/submitted-by/${orgId}`,
      );
      return response.data;
    } catch (error) {
      console.error("❌ Error fetching Submitted By:", error);
      return [];
    }
  },

  // 🔹 Ticket Type
  getTicketType: async (orgId) => {
    try {
      const response = await axios.get(
        `${Base_URL}/TicketDropdownData/ticket-type/${orgId}`,
      );
      return response.data;
    } catch (error) {
      console.error("❌ Error fetching Ticket Type:", error);
      return [];
    }
  },

  // 🔹 Ticket Logged Type
  getTicketLoggedType: async (orgId, typeGuid) => {
    try {
      const response = await axios.get(
        `${Base_URL}/TicketDropdownData/ticket-logged-type`,
        {
          params: { orgId, typeGuid },
        },
      );
      return response.data;
    } catch (error) {
      console.error("❌ Error fetching Ticket Logged Type:", error);
      return [];
    }
  },

  // 🔹 Ticket Category
  getTicketCategory: async (orgId, ticketLogGuid) => {
    try {
      const response = await axios.get(
        `${Base_URL}/TicketDropdownData/ticket-category`,
        {
          params: { orgId, ticketLogGuid },
        },
      );
      return response.data;
    } catch (error) {
      console.error("❌ Error fetching Ticket Category:", error);
      return [];
    }
  },

  // 🔹 Team Assigned
  getTeamAssigned: async (orgId, projectId) => {
    try {
      const response = await axios.get(
        `${Base_URL}/TicketDropdownData/team-assigned`,
        {
          params: { orgId, projectId },
        },
      );
      return response.data;
    } catch (error) {
      console.error("❌ Error fetching Team Assigned:", error);
      return [];
    }
  },

  // 🔹 Customer / Client
  getCustomer: async (orgId, projectId) => {
    try {
      const response = await axios.get(
        `${Base_URL}/TicketDropdownData/customer`,
        {
          params: { orgId, projectId },
        },
      );
      return response.data;
    } catch (error) {
      console.error("❌ Error fetching Customer:", error);
      return [];
    }
  },

  // 🔹 Partner / Vendor
  getPartner: async (orgId, projectId) => {
    try {
      const response = await axios.get(
        `${Base_URL}/TicketDropdownData/partner`,
        {
          params: { orgId, projectId },
        },
      );
      return response.data;
    } catch (error) {
      console.error("❌ Error fetching Partner:", error);
      return [];
    }
  },

  // 🔹 Get Contact GUID by OrgId and UserId
  // In TicketApiOrg.js - Update the getContactGuid function
  getContactGuid: async (orgId, userId) => {
    try {
      if (!orgId || !userId) {
        console.warn("⚠️ orgId and userId are required");
        return null;
      }

      const response = await axios.get(
        `${Base_URL}/ProjectDropdown/contact-guid`,
        {
          params: { orgId, userId },
        },
      );

      console.log("✅ Contact GUID API response:", response.data);

      // Extract the contactGuid property from the response object
      let contactGuid = null;
      if (response.data && response.data.contactGuid) {
        contactGuid = response.data.contactGuid;
        console.log("✅ Extracted Contact GUID:", contactGuid);
        return contactGuid;
      } else if (typeof response.data === "string") {
        // Fallback if response is directly a string
        return response.data;
      } else {
        console.error("❌ Unexpected response format:", response.data);
        return null;
      }
    } catch (error) {
      console.error("❌ Error fetching Contact GUID:", error);
      return null;
    }
  },

  // 🔹 Contact Names (Bulk by GUIDs)
  // 🔹 Contact Names (Bulk by GUIDs) - FIXED to use POST
  getContactNames: async (contactGuids) => {
    try {
      // Make sure contactGuids is an array
      const guidsArray = Array.isArray(contactGuids)
        ? contactGuids
        : [contactGuids];

      const response = await axios.post(
        `${Base_URL}/TicketDropdownData/contact-names`,
        {
          contactGuids: guidsArray,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      console.log("✅ Contact names fetched successfully:", response.data);
      return response.data;
    } catch (error) {
      console.error("❌ Error fetching Contact Names:", error);
      return [];
    }
  },
  // 🔹 Projects by SubmittedBy
  getProjectsBySubmittedBy: async (orgId, submittedBy) => {
    try {
      if (!orgId || !submittedBy) {
        console.warn("⚠️ orgId and submittedBy are required");
        return [];
      }

      const response = await axios.get(
        `${Base_URL}/TicketDropdownData/projects-by-submittedby`,
        {
          params: { orgId, submittedBy },
        },
      );

      return response.data;
    } catch (error) {
      console.error("❌ Error fetching Projects by SubmittedBy:", error);
      return [];
    }
  },
};

// In TicketApiOrg.js - Add this export
export const getContactNames = async (contactGuids) => {
  try {
    const response = await axios.post(
      `${Base_URL}/TicketDropdownData/contact-names`,
      {
        contactGuids: contactGuids, // ✅ MUST be array
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("❌ Error fetching Contact Names:", error);
    return [];
  }
};

export const getTicketMetaNames = async (
  typeGuids,
  logGuids,
  categoryGuids,
) => {
  try {
    const params = {};

    // ✅ Only add parameters if they have values
    if (typeGuids) params.typeGuids = typeGuids;
    if (logGuids) params.logGuids = logGuids;
    if (categoryGuids) params.categoryGuids = categoryGuids;

    // ✅ If no parameters, return empty array without making API call
    if (Object.keys(params).length === 0) {
      console.log("No parameters provided to getTicketMetaNames");
      return [];
    }

    const response = await axios.get(
      `${Base_URL}/TicketDropdownData/ticket-meta-names`,
      { params },
    );
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching ticket meta names:", error);
    return [];
  }
};

// Update remark
export const updateTicketRemark = async (ticketLogGuid, data) => {
  try {
    const response = await axios.put(
      `${Base_URL}/TicketBasedOrganization/UpdateRemark/${ticketLogGuid}`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("❌ Error updating ticket remark:", error);
    throw error;
  }
};

// Delete remark
export const deleteTicketRemark = async (ticketLogGuid, deletedBy) => {
  try {
    const response = await axios.delete(
      `${Base_URL}/TicketBasedOrganization/DeleteRemark/${ticketLogGuid}`,
      { params: { deletedBy } },
    );
    return response.data;
  } catch (error) {
    console.error("❌ Error deleting ticket remark:", error);
    throw error;
  }
};

// =====================================================
// 🎯 UPDATED TICKET VIEW CONTROLLER APIS
// =====================================================

// =====================================================
// 🎯 UPDATED TICKET VIEW CONTROLLER APIS
// =====================================================

// Get tickets by Organization ID
export const getTicketsByOrgIdNew = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketView/GetTicketsByOrg/${orgId}`,
    );
    console.log("Fetched tickets for orgId", orgId, response.data);

    // FIX: Check for lowercase 'success' instead of uppercase 'Success'
    if (response.data?.success === true) {
      return response.data?.data || [];
    }
    return [];
  } catch (error) {
    console.error(`Error fetching tickets for orgId ${orgId}:`, error);
    throw error;
  }
};

// Get tickets by Assigned Resource
export const getTicketsByAssignedResourceNew = async (resourceId) => {
  try {
    if (!resourceId) {
      throw new Error("resourceId is required");
    }
    const response = await axios.get(
      `${Base_URL}/TicketView/GetTicketsByAssignedResource/${resourceId}`,
    );
    // FIX: Check for lowercase 'success'
    if (response.data?.success === true) {
      return response.data?.data || [];
    }
    return [];
  } catch (error) {
    console.error(`Error fetching tickets for resource ${resourceId}:`, error);
    throw error.response?.data || error;
  }
};

// Get tickets by From Mail
// Get tickets by From Mail
export const getTicketsByFromMailNew = async (email, orgId = null) => {
  try {
    if (!email) {
      throw new Error("Email is required");
    }
    const params = { email };
    if (orgId) {
      params.orgId = orgId;
    }
    const response = await axios.get(
      `${Base_URL}/TicketView/GetTicketsByFromMail`,
      { params },
    );
    // FIX: Check for lowercase 'success'
    if (response.data?.success === true) {
      return response.data?.data || [];
    }
    return [];
  } catch (error) {
    console.error(`Error fetching tickets for email ${email}:`, error);
    throw error;
  }
};

// Get attachments by ticket ID
export const getAttachmentsByTicketIdNew = async (ticketId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketView/GetAttachmentsByTicket/${ticketId}`,
    );
    console.log("Fetched attachments for ticket", ticketId, response.data);
    // FIX: Check for lowercase 'success'
    if (response.data?.success === true) {
      return response.data?.data || [];
    }
    return [];
  } catch (error) {
    console.error(`Error fetching attachments for ticket ${ticketId}:`, error);
    throw error;
  }
};

// Get tickets by Project ID
export const getTicketsByProjectIdNew = async (projectId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketView/GetTicketsByProject/${projectId}`,
    );
    if (response.data?.Success) {
      return response.data.Data || [];
    }
    return [];
  } catch (error) {
    console.error(`Error fetching tickets for projectId ${projectId}:`, error);
    throw error;
  }
};

// Get single ticket by ID
export const getTicketByIdNew = async (ticketId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketView/GetTicketById/${ticketId}`,
    );
    if (response.data?.Success) {
      return response.data.Data;
    }
    return null;
  } catch (error) {
    console.error(`Error fetching ticket with ID ${ticketId}:`, error);
    throw error;
  }
};

// Search tickets with advanced filters
export const searchTickets = async (searchParams) => {
  try {
    const response = await axios.post(
      `${Base_URL}/TicketView/Search`,
      searchParams,
    );
    if (response.data?.Success) {
      return response.data.Data || [];
    }
    return [];
  } catch (error) {
    console.error("Error searching tickets:", error);
    throw error;
  }
};

// Get single attachment by ID
export const getAttachmentByIdNew = async (id) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketView/GetAttachmentById/${id}`,
    );
    if (response.data?.Success) {
      return response.data.Data;
    }
    return null;
  } catch (error) {
    console.error(`Error fetching attachment with ID ${id}:`, error);
    throw error;
  }
};
